import {
  DO_NOT_EXPORT,
  AWAITING_DECISION,
  NOT_SUBMITTED,
} from '$utils/overrideConstants';

export default {
  [AWAITING_DECISION]: 'Awaiting decision',
  [NOT_SUBMITTED]: 'Not submitted',
  [DO_NOT_EXPORT]: 'Do not export',
};
